import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import CompetitorDataForm from "../../components/Forms/CompetitorDataForm";
import useAuth from "../../hooks/useAuth";
import {
  submitApplicationSchema,
  submitBusinessPlanSchema,
  submitBusinessProfileSchema,
  submitExistingBusinessProfileSchema,
} from "../../services/SchemaService";
import ExecutiveSummaryForm from "../../components/Forms/ExecutiveSummaryForm";
import BusinessProfileForm from "../../components/Forms/BusinessProfileForm";
import BusinessIdeaForm from "../../components/Forms/BusinessIdeaForm";
import useApplication from "../../hooks/useApplication";
import {
  Button,
  Checkbox,
  Column,
  Form,
  FormGroup,
  Loading,
  RadioButton,
  RadioButtonGroup,
  Row,
  TextArea,
  TextInput,
} from "carbon-components-react";
import SubmitButton from "../../components/Buttons/SubmitButton";
import CancelButton from "../../components/Buttons/CancelButton";
import { ButtonSet } from "carbon-components-react";
import { Edit24 } from "@carbon/icons-react";
import { SendAlt24 } from "@carbon/icons-react";
import http from "../../http-common";
import { toast } from "react-toastify";
import useGet from "../../hooks/useGet";
import useBusinessPlan from "../../hooks/useBusinessPlan";
import ProvinceCombo from "../../components/Combos/ProvinceCombo";
import DistrictCombo from "../../components/Combos/DistrictCombo";
import GenericCombo from "../../components/Combos/GenericCombo";
import MarketAnalysisForm from "../../components/Forms/MarketAnalysisForm";
import CapacityAnalysisForm from "../../components/Forms/CapacityAnalysisForm";
import WorkersForm from "../../components/Forms/WorkersForm";
import FinancialPlanForm from "../../components/Forms/FinancialPlanForm";
import EnvironmentalSocialAnalysisForm from "../../components/Forms/EnvironmentalSocialAnalysisForm";
import DataSheetForm from "../../components/Forms/DataSheetForm";
import ExistingBusinessProfileForm from "../../components/Forms/ExistingBusinessProfileForm";
import BusinessPlanIdeaForm from "../../components/Forms/BusinessPlanIdeaForm";

const ViewBusinessPlanPage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { businessPlan } = useBusinessPlan(uuid);
  const [hasBusinessCurrently, setHasBusinessCurrently] = useState(null);
  const { data: legalForms } = useGet("/utils/legal-forms");
  const [isOpen, setIsOpen] = useState(false);
  const { user, isCompetitor } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(
      businessPlan.hasBusinessCurrently !== null &&
        businessPlan.hasBusinessCurrently === "Sim"
        ? submitBusinessPlanSchema.concat(submitExistingBusinessProfileSchema)
        : submitBusinessPlanSchema
    ),
  });

  const onSubmit = async (data) => {
    try {
      const response = await http.post("/business-plan/submit/" + uuid);

      toast.success(
        "Plano de Negócio submetido com sucesso. Obrigado e boa sorte!"
      );
      setIsOpen(response.data.currentStatusCode === 1);
      //setIsOpen(false);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    reset(businessPlan);
    setIsOpen(businessPlan.currentStatusCode === 1);
    setHasBusinessCurrently(businessPlan.hasBusinessCurrently);
    setTimeout(() => {
      setIsLoading(false);
    }, "2000");
  }, [uuid, businessPlan]);

  return (
    <>
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Card title="Plano de Negócio">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <DataSheetForm
            register={register}
            control={control}
            errors={errors}
            disabled={true}
            businessPlan={businessPlan}
            hasBusinessCurrently={hasBusinessCurrently}
            setHasBusinessCurrently={setHasBusinessCurrently}
          />
          {hasBusinessCurrently !== null && hasBusinessCurrently === "Sim" && (
            <ExistingBusinessProfileForm
              register={register}
              errors={errors}
              setHasBusinessCurrently={setHasBusinessCurrently}
              disabled={true}
              businessPlan={businessPlan}
            />
          )}
          <BusinessPlanIdeaForm
            register={register}
            errors={errors}
            disabled={true}
          />
          <CapacityAnalysisForm
            register={register}
            errors={errors}
            disabled={true}
          />
          <MarketAnalysisForm
            register={register}
            errors={errors}
            disabled={true}
          />
          <WorkersForm register={register} errors={errors} disabled={true} />
          <FinancialPlanForm
            register={register}
            errors={errors}
            disabled={true}
            businessPlan={businessPlan}
            getValues={getValues}
          />
          <EnvironmentalSocialAnalysisForm
            businessPlan={businessPlan}
            register={register}
            errors={errors}
            disabled={true}
          />
          <div className="form-buttons">
            <ButtonSet>
              {isOpen && (
                <Button
                  renderIcon={Edit24}
                  iconDescription="Editar"
                  onClick={() =>
                    navigate("../editar-plano-de-negocio/" + businessPlan.uuid)
                  }
                >
                  Editar
                </Button>
              )}
              <CancelButton
                label={"Voltar"}
                navigateTo={
                  isCompetitor
                    ? isOpen
                      ? "../editar-plano-de-negocio/" + businessPlan.uuid
                      : "../inicio"
                    : ""
                }
              />
            </ButtonSet>
            {isOpen && isCompetitor && (
              <ButtonSet>
                <SubmitButton
                  label="Submeter"
                  icon={SendAlt24}
                  className="emprega-bg-orange"
                />
              </ButtonSet>
            )}
          </div>
        </Form>
      </Card>
    </>
  );
};

export default ViewBusinessPlanPage;
